import React, { useEffect, useState } from "react";
import { object, shape } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import SectionMast from "../section-mast";
import { AuthorInfo } from "./author-card/AuthorInfo";
import { HorizontalStory } from "./horizontal-stories/HorizontalStory";
import { TrendingStories } from "../section-page/trending-stories/TrendingStories";
import { getMenuGroups } from "../../../../api/utils";

import "./author.m.css";

export const AuthorPage = (props) => {
  const [menuGroupsList, setMenuGroupsList] = useState([]);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const ismobile = deviceType === "mobile";

  const sideAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_1"], {}));
  const sideAd2 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_2"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  useEffect(async () => {
    setMenuGroupsList(await getMenuGroups());
  }, []);
  const stories = props.data.authorCollection.items.map(({ story }) => story) || [];
  const [visibleItems, setVisibleItems] = useState(12); // Initial number of visible items
  const loadMoreStories = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 12);
  };
  return (
    <div styleName="author-page-container">
      <div className="container" styleName="wrapper">
        <div styleName="authorContainer">
          <AuthorInfo author={props?.data?.author} ismobile={ismobile} />
          <div styleName="row-separator"></div>
          <h1 styleName="article-list-title">Articles from the author</h1>
          {stories.length > 0 ? (
            <div styleName="articleList">
              {stories.slice(0, visibleItems).map((story) => (
                <HorizontalStory key={story?.id} story={story} />
              ))}
            </div>
          ) : (
            <div>
              <p styleName="no-article">We’re sorry, but no articles were found :(</p>
            </div>
          )}
          {visibleItems < stories.length && (
            <p styleName="loadmore-button" onClick={loadMoreStories}>
              LOAD MORE
            </p>
          )}
        </div>

        <div styleName="right-column">
          <div styleName="right-top-ad-slot">
            <DfpComponent adStyleName="ad-slot-size-300x600" id={sideAd1?.id} />
          </div>
          <TrendingStories />
          {isDesktop && (
            <div styleName="right-bottom-ad-slot">
              <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={sideAd2?.id} />
            </div>
          )}
        </div>
      </div>
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName={"ad-slot-size-970x250"} id={footerAd?.id} />
      </div>
    </div>
  );
};

AuthorPage.propTypes = {
  data: shape({
    author: object,
    authorCollection: object,
  }),
};
